import gql from 'graphql-tag';

export default gql`
  query getProfile($userId: String, $profileId: Int) {
    getProfile(userId: $userId, profileId: $profileId) {
      userId
      isEmailConfirmed
      isFacebookConnected
      isGoogleConnected
      isPhoneVerified
      isIdVerification
      firstName
      lastName
      createdAt
      location
      picture
      profileId
      reviewsCount
      reviewsStarRating
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components_new/Inbox/userProfileQ.js